import React, { Component } from 'react';
import '../../../scss/components/pages/staffList.scss';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import Pagination from '../../Pagination';
import EditStaffJob from '../../EditStaffJob';

import { 
  getStaffList,
  editStaffJob,
  addStaff,
  InitAPIStatus,
  getJobTypeList,
  sortStafflist
} from '../../../store/action';

class StaffJobList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'StaffList',
      editType: 'ADD',
      isEditShow: false,
      currPage: 1,
      countOfPage: 10,
      isOpenQrcodeBlock: false,
      QrcordText: '',
      QrcordName: '',
      QrcordJobType: '',
      editInformation: {
        id: -1,
        realName: '',
        //預設
        jobTypeId: 0,
        //板橋店
        jobTypeId1: 0,
        //海大店
        jobTypeId2: 0,
                //北大店
                jobTypeId3: 0,
        status: 0
      },
      searchNameInput: ''
    }
    this.toggleEditBlockShow = this.toggleEditBlockShow.bind(this);
    this.handleSaveStaff = this.handleSaveStaff.bind(this);
    this.openEditStaffBlok = this.openEditStaffBlok.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
    this.handleToggleOpenQrcordBlcok = this.handleToggleOpenQrcordBlcok.bind(this);
    this.inputSearchChange = this.inputSearchChange.bind(this);

  }

  componentDidMount() {
    this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput,1,'all');
    this.props.getJobTypeList();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.SendAPIState === true) {
      swal({
        type: 'success',
        title: this.state.editType === 'ADD' ? '員工新增成功' : '員工修改成功',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
        this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput,1,'all');
        this.setState({
          isEditShow: false
        })
      });
      return 
    } else if (nextProps.SendAPIState === 2) {
      swal({
        type: 'error',
        title: '員工身分重複',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    }
  }

  openEditStaffBlok(staffId) {
    let staffObj = this.props.staffListState.users.filter(staff => staff.id === staffId);
    let newObj = JSON.parse(JSON.stringify(staffObj[0]));
    newObj.jobs.forEach((element) => {
      if(element.storeName === '總店'){
        newObj.jobTypeId1=element.jobId;
      }else if(element.storeName === '海大店'){
        newObj.jobTypeId2=element.jobId;
      }else if(element.storeName === '北大店'){
        newObj.jobTypeId3=element.jobId;
      }
    });
    this.setState({
      editType: 'EDIT',
      editInformation: newObj
    }, () => {
      this.toggleEditBlockShow();
    })
  }
  
  toggleEditBlockShow() {
    if (this.state.isEditShow === true) {
      let newObj = JSON.parse(JSON.stringify((this.state.editInformation)));
      newObj.id = -1;
      newObj.realName = '';
      newObj.jobTypeId = 0;
      newObj.status = 0;
      this.setState({
        editInformation: newObj,
        isEditShow: false
      });
    } else {
       this.setState({
        isEditShow: true
      })
    }
  }

  handleSaveStaff() {
    const { id,jobTypeId1,jobTypeId2,jobTypeId3 } = this.state.editInformation;
    if (jobTypeId1 === 0) {
      swal({
        type: 'error',
        title: '所有欄位必填!',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      });
      return
    } else {
      if(this.state.editType === 'EDIT') {

        var newObj = {
          userId: id,
          jobs:[
            {
              storeId:1,
              jobTypeId:jobTypeId1 ? jobTypeId1 : -1
            },
            {
              storeId:2,
              jobTypeId:jobTypeId2 ? jobTypeId2 : -1
            },
            {
              storeId:3,
              jobTypeId:jobTypeId3 ? jobTypeId3 : -1
            }
          ]
        }

        this.setState({currPage: 1});

        this.props.editStaffJob(newObj);
      }
    }
  }

  handleChangePage(page) {
    const { countOfPage } = this.state;
    this.setState({currPage: page},() => {
      this.props.getStaffList(this.state.currPage, countOfPage, this.state.searchNameInput,1,'all');
    })
  }

  handleOnChangeInput(key, e) {
    let newObj = Object.assign(this.state.editInformation);
    newObj[key] = parseInt(e.target.value);
    this.setState({
      editInformation: newObj
    });
  }

  handleToggleOpenQrcordBlcok(){
    this.setState({
      isOpenQrcodeBlock: !this.state.isOpenQrcodeBlock
    })
  }

  inputSearchChange(e) {
    this.setState({
      searchNameInput: e.target.value
    })
  }
  
  render() {
    let { users, count } = this.props.staffListState;
    let totalPage = Math.ceil(count / this.state.countOfPage);
    return (
      <div className="p-staff-list">
        <div className="u-block">
          <div className="u-title">員工列表</div>
          <div className="u-btn-group p-0" style={{justifyContent: 'space-between'}}>
            <div className="search-box" style={{display: 'flex'}}>
              <div className="date-input">
                <input className="u-form__input" value={this.state.searchNameInput} placeholder="請輸入姓名" onChange={this.inputSearchChange} 
                  onKeyPress={(event) => {
                    if(event.key === 'Enter'){
                      this.setState({currPage: 1},() => {
                        this.props.getStaffList(1, this.state.countOfPage, this.state.searchNameInput,1,'all');
                      })
                    }
                  }}/>
              </div>
              <button className="btn btn-md save m-l-8" onClick={() => {
                this.setState({currPage: 1},() => {
                  this.props.getStaffList(1, this.state.countOfPage, this.state.searchNameInput,1,'all');
                })
              }}>查詢</button>
            </div>
          </div>
          <div className="u-table-responsive">
            <table className="u-table u-table-border u-table-striped">
              <thead>
                <tr>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('createAt')}}>建檔時間<i className="fas fa-angle-down"></i></th>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('id')}}>ID<i className="fas fa-angle-down"></i></th>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('realName')}}>全名<i className="fas fa-angle-down"></i></th>
                    <th>所屬分店</th>
                    <th>原始職位</th>
                    <th>所有職位</th>
                    <th></th>
                </tr>
              </thead>
              <tbody>
                {
                  users.map(user => (
                    <tr key={user.id}>
                      <td>{user.createAt.substr(0, 10)}</td>
                      <td>{user.id}</td>
                      <td>{user.realName}</td>
                      <td>{user.originStore}</td>
                      <td>{user.jobType}</td>
                      <td>{user.jobs ? user.jobs.map(jobType => (
                          <p key={`${user.id}${jobType.storeName}${jobType.jobId}`}>{jobType.storeName} : {jobType.jobName}</p>
                          )):''}
                      </td>
                      <td>
                          <a href="/" className="btn btn-md main-color" onClick={(e)=>{
                          e.preventDefault();
                          this.openEditStaffBlok(user.id);
                        }}>編輯</a>
                      </td>
                    </tr>)
                  )
                }
              </tbody>
            </table>
          </div>
          <Pagination
            currPage={this.state.currPage} totalPage={totalPage}
            onChangPage={this.handleChangePage}
          />
          <EditStaffJob 
            isShow={this.state.isEditShow}
            editInformation={this.state.editInformation}
            jobTypeArray={this.props.jobTypeState}
            onChangeFunc={this.handleOnChangeInput}
            saveFunc={this.handleSaveStaff}
            toggleFunc={this.toggleEditBlockShow}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  loginState: store.loginState,
  SendAPIState: store.SendAPIStatusState,
  jobTypeState: store.jobTypeState,
  staffListState: store.staffListState
})

export default connect(mapStateToProps,{
  getStaffList,
  getJobTypeList,
  InitAPIStatus,
  addStaff,
  editStaffJob,
  sortStafflist
})(StaffJobList)

